<section class="hist ds">
	<!-- Cabecera informativa: marca claramente que es lectura, no edición -->
	<header class="hist-head">
		<span class="hist-head-ic"><mat-icon [inline]="true">history</mat-icon></span>
		<div class="hist-head-tx">
			<h3>{{ "historial.title" | translate }}</h3>
			<p>{{ "historial.subtitle" | translate }}</p>
		</div>
		<span class="hist-badge">{{ "historial.readonly" | translate }}</span>
	</header>

	<div class="hist-loading" *ngIf="loading">
		<mat-icon [inline]="true">hourglass_empty</mat-icon>
		<span>{{ "historial.loading" | translate }}</span>
	</div>

	<app-empty-state
		*ngIf="!loading && eventos.length === 0"
		icon="history"
		tone="neutral"
		[title]="'historial.empty.title' | translate"
		[message]="'historial.empty.message' | translate"
	></app-empty-state>

	<ol class="hist-timeline" *ngIf="!loading && eventos.length > 0">
		<li
			class="hist-ev"
			*ngFor="let ev of eventos; let i = index; trackBy: trackEvento"
			[ngClass]="claseOperacion(ev.operacion)"
			[class.is-gap]="hayGapGrande(i)"
		>
			<span class="hist-node"></span>
			<div class="hist-ev-body">
				<div class="hist-ev-head">
					<span class="hist-op">
						<mat-icon [inline]="true">{{ iconoOperacion(ev.operacion) }}</mat-icon>
						{{ "historial.op." + ev.operacion | translate }}
					</span>
					<span class="hist-meta" [title]="ev.fecha | date: 'dd/MM/yyyy HH:mm'">
						{{ ev.usuario }} · {{ tiempoRelativo(ev.fecha) }}
					</span>
				</div>

				<ul class="hist-fields" *ngIf="ev.campos.length > 0">
					<li class="hist-field" *ngFor="let c of ev.campos">
						<span class="hist-field-name">{{ etiquetaCampo(c.campo) }}</span>
						<span class="hist-field-old">{{ mostrar(c.valorAnterior) }}</span>
						<mat-icon class="hist-arrow" [inline]="true">arrow_forward</mat-icon>
						<span class="hist-field-new">{{ mostrar(c.valorNuevo) }}</span>
					</li>
				</ul>
			</div>

			<!-- Salto temporal notable: rail punteado + etiqueta del intervalo -->
			<span class="hist-gap" *ngIf="hayGapGrande(i)">{{ gapTexto(i) }}</span>
		</li>
	</ol>
</section>
